import { put, call, takeLatest } from 'redux-saga/effects'
import { ACTION_TYPES } from 'store/reducers/bankInfo'
import { accountType, ownerTypes, banks } from 'services'

const {
  BANK_INFO_ACCOUNT_REQUEST,
  BANK_INFO_ACCOUNT_SUCCESS,
  BANK_INFO_ACCOUNT_ERROR,
  BANKS_LIST_REQUEST,
  BANKS_LIST_SUCCESS,
  BANKS_LIST_ERROR
} = ACTION_TYPES

export function *bankInfoRequest() {
  try {
    const responseAccountType = yield call(accountType)
    const responseOwnerTypes = yield call(ownerTypes)

    yield put({
      type: BANK_INFO_ACCOUNT_SUCCESS,
      payload: {
        ownerTypes: responseOwnerTypes.data,
        accountType: responseAccountType.data
      }
    })
  } catch (err) {
    yield put({ type: BANK_INFO_ACCOUNT_ERROR, error: err })
  }
}

export function *banksListRequest({ payload }) {
  try {
    const responseBanks = yield call(banks, payload.SHOW_FAVORITES)
    yield put({
      type: BANKS_LIST_SUCCESS,
      payload: {
        banks: responseBanks.data
      }
    })
  } catch (err) {
    yield put({ type: BANKS_LIST_ERROR, error: err })
  }
}

export function *watchBanksList() {
  yield takeLatest(BANKS_LIST_REQUEST, banksListRequest)
}

export function *watchBankInfo() {
  yield takeLatest(BANK_INFO_ACCOUNT_REQUEST, bankInfoRequest)
}
